/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RatchetMetricType {
    MOIC = 'MOIC',
    XIRR = 'XIRR',
    MOIC_AND_XIRR = 'MOIC_AND_XIRR',
}
